<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản đi TĐHVP
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <search
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"
                    >
                      <span class="label-input width__auto">Ngày văn bản</span>
                      <el-date-picker
                        v-model="docDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="docDateRangeChanged"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <tdhvp-doc-out-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </search>
              </template>
            </sub-header>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt margin-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'" />
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__right clickable"
                    @click="doSort('publisherName')"
                  >
                    Đơn vị ban hành
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'publisherName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in vbOutgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <i class="fas fa-file color__silver"></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode" class="margin-right-5"
                              >#{{ item.docCode }}</span
                            >

                            <el-tag
                              v-if="item.docTypeName"
                              size="medium"
                              class="margin-right-5"
                              >{{ item.docTypeName }}
                            </el-tag>

                            <tdhvp-doc-priority-tag
                              v-if="!!item.priorityName"
                              :priorityName="item.priorityName"
                              class="margin-right-5"
                            >
                            </tdhvp-doc-priority-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv1 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          <i
                            class="color__blue fas fa-building margin-right-5"
                          ></i>
                          {{ item.publisherName || "-" }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          <i
                            class="color__blue fas fa-calendar margin-right-5"
                          ></i>
                          {{
                            item.docDate
                              | dateFormatter({
                                nullValue: "-",
                                dateFormat: "DD/MM/YYYY"
                              })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
    </template>
  </list-template>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MainHeader from "../../../components/header/main-header";
import SubHeader from "../../../components/main/sub-header";
import dateUtils from "../../../dateUtils";
import dateFormatter from "../../../filters/dateFormatter";
import utils from "../../../services/utils";
import ListTemplate from "../../common/list";
import Search from "../../common/search";
import SortCaret from "../../doc-out/SortCaret";
import TdhvpDocPriorityTag from "../common/tdhvp-doc-priority-tag";
import TdhvpDocOutAdvanceSearchDialog from "./tdhvp-doc-out-advance-search-dialog";

export default {
  name: "tdhvp-doc-out-index-common",
  props: ["listFn"],
  components: {
    TdhvpDocOutAdvanceSearchDialog,
    TdhvpDocPriorityTag,
    SortCaret,
    Search,
    SubHeader,
    MainHeader,
    ListTemplate,
    VuePerfectScrollbar
  },
  filters: { dateFormatter },

  data() {
    return {
      dateQuickFilterOption: null,
      docDateRange: null,
      vbOutgoingDocs: [],
      advanceSearchForm: {
        docCode: null,
        fromDocDate: null,
        toDocDate: null,
        quote: null
      },
      keyword: null,
      order: null,
      sort: null,
      page: null,
      size: 10,
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      if (newValue) this.isEnableAdvanceSearchDialog = true;
    }
  },

  created() {
    this.dateQuickFilterOption = this.buildDateQuickFilterOption();
    this.initQuery();
  },

  methods: {
    buildDateQuickFilterOption() {
      return utils.getDateQuickFilterOptionForSearchTdhvp();
    },

    viewDetail(item) {
      this.$emit("viewDetail", { item });
      // this.$router.push({
      //   name: "tdhvpDocOutDetail",
      //   params: { id: item.id, userDeptRoleId: this.userDeptRoleId },
      //   query: this.$route.query
      // });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };

      return this.listFn({ form: this.convertToSubmitForm(), pageable }).then(
        items => {
          items && this.vbOutgoingDocs.push(...items);
          return items;
        }
      );

      // return vbOutgoingDocUserTdhvpViewService
      //   .findAll(this.convertToSubmitForm(), pageable)
      //   .then(response => {
      //     let items = response.data;
      //     items && this.vbOutgoingDocs.push(...items);
      //     return items;
      //   });
    },

    infiniteHandler($state) {
      return this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    doSearch() {
      //store lại tham số lên url;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.convertToQueryParams()
      });
      this.vbOutgoingDocs = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    simpleSearch(keyword) {
      this.keyword = keyword;
      this.advanceSearchForm.docCode = null;
      this.advanceSearchForm.quote = null;
      this.doSearch();
    },

    docDateRangeChanged() {
      utils.timeRangeChanged(this.docDateRange, (from_, to_) => {
        this.advanceSearchForm.fromDocDate = from_;
        this.advanceSearchForm.toDocDate = to_;
      });
      this.doSearch();
    },

    advanceSearch(advanceSearchForm) {
      this.isOpenAdvanceSearchDialog = false;
      this.advanceSearchForm.docCode = advanceSearchForm.docCode;
      this.advanceSearchForm.quote = advanceSearchForm.quote;
      this.advanceSearchForm.fromDocDate = advanceSearchForm.fromDocDate;
      this.advanceSearchForm.toDocDate = advanceSearchForm.toDocDate;
      this.initDocDateRange();
      this.doSearch();
    },

    convertToSubmitForm() {
      return {
        docCode: this.advanceSearchForm.docCode,
        fromDocDate: this.advanceSearchForm.fromDocDate,
        toDocDate: this.advanceSearchForm.toDocDate,
        quote: this.advanceSearchForm.quote,
        keyword: this.keyword
      };
    },

    convertToQueryParams() {
      return {
        docCode: this.advanceSearchForm.docCode || undefined,
        fromDocDate: this.advanceSearchForm.fromDocDate || undefined,
        toDocDate: this.advanceSearchForm.toDocDate || undefined,
        quote: this.advanceSearchForm.quote || undefined,
        keyword: this.keyword || undefined,
        order: this.order,
        sort: this.sort
      };
    },

    initQuery() {
      let query = this.$route.query;
      this.advanceSearchForm.docCode = utils.getParamFromQuery(
        query,
        "docCode"
      );
      this.advanceSearchForm.quote = utils.getParamFromQuery(query, "quote");
      this.keyword = utils.getParamFromQuery(query, "keyword");
      this.advanceSearchForm.fromDocDate = utils.getIntParamsFromQuery(
        query,
        "fromDocDate"
      );
      this.advanceSearchForm.toDocDate = utils.getIntParamsFromQuery(
        query,
        "toDocDate"
      );
      this.sort = utils.getParamFromQuery(query, "sort");
      this.order = utils.getParamFromQuery(query, "order");
      this.initDocDateRange();
    },

    initDocDateRange() {
      if (
        !this.advanceSearchForm.fromDocDate ||
        !this.advanceSearchForm.toDocDate
      ) {
        utils.timeRangeChanged(
          (this.docDateRange = dateUtils.getRangeOfYear(2019, 2019)),
          (from_, to_) => {
            this.advanceSearchForm.fromDocDate = from_;
            this.advanceSearchForm.toDocDate = to_;
          }
        );
      } else {
        this.docDateRange = [
          new Date(this.advanceSearchForm.fromDocDate),
          new Date(this.advanceSearchForm.toDocDate)
        ];
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/doc-out/tdhvp-doc-out-index-common.vue